import React, { PureComponent } from 'react';
import styles from './index.css';
import { WxLaunchApp } from '../../../../wxLaunchApp';
const { callApp } = require('@ifeng-fe/callapp');
/**
 * 提示：试看结束，跳转客户端引流
 */
class TipsMask extends PureComponent {
    constructor(props) {
        super(props);
        this.handleCalledApp = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
            let { callAppConfig } = this.props;
            if (isCallApp && callAppConfig) {
                callAppConfig.isJumpQQlink = isJumpQQlink;
                callApp(callAppConfig);
            }
        };
        this.sliceContent = '';
    }
    render() {
        const { content, videoWxLanch } = this.props;
        this.sliceContent = content || '去凤凰新闻客户端<br />观看完整版';
        // 截取移动端展示截流内容的 前16个字
        this.sliceContent = this.sliceContent.slice(0, 16);
        return (React.createElement("div", { className: styles.tipsMask },
            React.createElement("div", { className: styles.textCenter },
                React.createElement("p", { className: styles.tipsText, dangerouslySetInnerHTML: { __html: this.sliceContent } }),
                React.createElement("div", { className: styles.openClient, onClick: this.handleCalledApp },
                    "\u6253\u5F00\u51E4\u51F0\u65B0\u95FB",
                    videoWxLanch &&
                        !videoWxLanch.isVideoShare &&
                        videoWxLanch.wxLaunchSwitch &&
                        React.createElement(WxLaunchApp, { launchType: videoWxLanch.wxLaunchType, schemeLink: videoWxLanch.schemeLink, launchAppClick: this.handleCalledApp.bind(this, true, false, false), launchAppFail: this.handleCalledApp.bind(this, false, true, true) })))));
    }
}
export default TipsMask;
